(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const animateRows = (root) => {
      if (reduceMotion) return;
      const rows = root.querySelectorAll('.cart-items__table-row:not(.is-in)');
      rows.forEach((row, i) => {
        row.style.setProperty('--row-index', i);
        row.classList.add('is-entering');
      });
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          rows.forEach((row) => {
            row.classList.remove('is-entering');
            row.classList.add('is-in');
          });
        })
      );
    };

    const pulseTotals = () => {
      document
        .querySelectorAll('.cart-page__summary .totals__total-value, .cart-page__summary .cart-totals__original-container')
        .forEach((el) => {
          el.classList.remove('is-pulsing');
          void el.offsetWidth;
          el.classList.add('is-pulsing');
        });
    };

    const dim = (e) => {
      const row = e.target.closest?.('.cart-items__table-row');
      if (row && e.target.closest('button, input')) row.classList.add('is-updating');
    };

    let timer;
    const onCartChange = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const page = document.querySelector('[data-cart-page]');
        if (page) animateRows(page);
        document.querySelectorAll('.cart-items__table-row.is-updating').forEach((r) => r.classList.remove('is-updating'));
        pulseTotals();
      }, 120);
    };

    const init = () => {
      const page = document.querySelector('[data-cart-page]');
      if (!page) return;

      animateRows(page);

      page.addEventListener('click', dim);
      page.addEventListener('change', dim);

      new MutationObserver(onCartChange).observe(page, { childList: true, subtree: true });
      document.addEventListener('cart:update', onCartChange);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const hash = window.location.hash;
    if (hash.length < 2) return;

    const scrollToHash = () => {
      let target = null;
      try {
        target = document.getElementById(decodeURIComponent(hash.slice(1)));
      } catch (e) {
        return;
      }
      if (!target) return;

      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToHash, { once: true });
    } else {
      scrollToHash();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
